import { DownloadLink } from 'components/DownloadLink'
import {
  EntityList,
  EntityListProps,
  renderEnum,
  renderPersona,
  renderTimeAgo,
} from 'components/EntityList'
import { FileTemplate } from 'model'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type FileTemplateListProps = EntityListProps<FileTemplate>

export const FileTemplateList: React.FunctionComponent<
  FileTemplateListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('type', {
        minWidth: 140,
        isGrouped: true,
        getGroupValue: (item: FileTemplate) =>
          t(`enum.fileTemplateType.${item.type}`),
        onRender: renderEnum(t, 'fileTemplateType'),
      }),
      fieldColumn('provingGround', {
        minWidth: 140,
        getGroupValue: (item: FileTemplate) =>
          item.provingGround
            ? item.provingGround.title
            : t('model.fileTemplate.allProvingGrounds'),
        onRender: (item: FileTemplate) => {
          if (item.provingGround) {
            return item.provingGround.title
          } else {
            return t('model.fileTemplate.allProvingGrounds')
          }
        },
      }),
      fieldColumn('fileName', {
        minWidth: 150,
        ungroupable: true,
        onRender: (item: FileTemplate) => (
          <DownloadLink uri={item.uri}>{item.fileName}</DownloadLink>
        ),
      }),
      fieldColumn('modifiedBy', {
        onRender: renderPersona({
          size: PersonaSize.size24,
        }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('modified', {
        ungroupable: true,
        onRender: renderTimeAgo,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <>
      <EntityList
        alternate={true}
        stickyHeader={true}
        selectionMode={SelectionMode.multiple}
        items={items}
        constrainMode={ConstrainMode.horizontalConstrained}
        columns={columns}
        {...props}
      />
    </>
  )
}
